import React from "react";

export default function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between mb-6 gap-4 flex-wrap">
      <div>
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="font-display text-3xl tracking-tight">{title}</h1>
        {subtitle && <div className="text-sm text-[color:var(--oz-text-dim)] mt-1">{subtitle}</div>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
